// Mock data for Scenario Inputs

// TOU Rate Library - mock data based on EnergyRate.js format
export const mockTOULibrary = [
  {
    id: 'sce-ev9',
    name: 'SCE EV-9 Schedule',
    utility: 'Southern California Edison',
    state: 'CA',
    description: '2kV-50kV customers',
    rates: [
      { x: 0, y: 0.17133 }, { x: 1, y: 0.17133 }, { x: 2, y: 0.17133 },
      { x: 3, y: 0.17133 }, { x: 4, y: 0.17133 }, { x: 5, y: 0.17133 },
      { x: 6, y: 0.17133 }, { x: 7, y: 0.17133 }, { x: 8, y: 0.17133 },
      { x: 9, y: 0.17133 }, { x: 10, y: 0.17133 }, { x: 11, y: 0.17133 },
      { x: 12, y: 0.17133 }, { x: 13, y: 0.17133 }, { x: 14, y: 0.17133 },
      { x: 15, y: 0.17133 }, { x: 16, y: 0.46034 }, { x: 17, y: 0.46034 },
      { x: 18, y: 0.46034 }, { x: 19, y: 0.46034 }, { x: 20, y: 0.46034 },
      { x: 21, y: 0.17133 }, { x: 22, y: 0.17133 }, { x: 23, y: 0.17133 }
    ]
  },
  {
    id: 'pge-ev2',
    name: 'PG&E EV2-A',
    utility: 'Pacific Gas & Electric',
    state: 'CA',
    description: 'Commercial EV charging rate',
    rates: [
      { x: 0, y: 0.15 }, { x: 1, y: 0.15 }, { x: 2, y: 0.15 },
      { x: 3, y: 0.15 }, { x: 4, y: 0.15 }, { x: 5, y: 0.15 },
      { x: 6, y: 0.18 }, { x: 7, y: 0.18 }, { x: 8, y: 0.22 },
      { x: 9, y: 0.22 }, { x: 10, y: 0.22 }, { x: 11, y: 0.22 },
      { x: 12, y: 0.22 }, { x: 13, y: 0.22 }, { x: 14, y: 0.22 },
      { x: 15, y: 0.22 }, { x: 16, y: 0.42 }, { x: 17, y: 0.42 },
      { x: 18, y: 0.42 }, { x: 19, y: 0.42 }, { x: 20, y: 0.42 },
      { x: 21, y: 0.22 }, { x: 22, y: 0.18 }, { x: 23, y: 0.15 }
    ]
  },
  {
    id: 'coned-business',
    name: 'Con Edison Business Time-of-Use',
    utility: 'Consolidated Edison',
    state: 'NY',
    description: 'Commercial TOU rate',
    rates: [
      { x: 0, y: 0.12 }, { x: 1, y: 0.12 }, { x: 2, y: 0.12 },
      { x: 3, y: 0.12 }, { x: 4, y: 0.12 }, { x: 5, y: 0.12 },
      { x: 6, y: 0.16 }, { x: 7, y: 0.16 }, { x: 8, y: 0.28 },
      { x: 9, y: 0.28 }, { x: 10, y: 0.28 }, { x: 11, y: 0.28 },
      { x: 12, y: 0.28 }, { x: 13, y: 0.28 }, { x: 14, y: 0.28 },
      { x: 15, y: 0.28 }, { x: 16, y: 0.38 }, { x: 17, y: 0.38 },
      { x: 18, y: 0.38 }, { x: 19, y: 0.28 }, { x: 20, y: 0.28 },
      { x: 21, y: 0.16 }, { x: 22, y: 0.12 }, { x: 23, y: 0.12 }
    ]
  }
];

// Vehicle Pricing Library
export const mockVehiclePricing = [
  {
    id: 'standard-2024',
    name: 'Standard 2024 Pricing',
    year: 2024,
    vehicles: [
      { class: 'Sedan', msrp: 42000, incentive: 7500 },
      { class: 'SUV', msrp: 55000, incentive: 7500 },
      { class: 'Truck', msrp: 65000, incentive: 7500 },
      { class: 'Transit Bus', msrp: 450000, incentive: 150000 },
      { class: 'School Bus', msrp: 350000, incentive: 100000 }
    ]
  },
  {
    id: 'forecast-2026',
    name: 'Forecast 2026 Pricing',
    year: 2026,
    vehicles: [
      { class: 'Sedan', msrp: 38000, incentive: 7500 },
      { class: 'SUV', msrp: 50000, incentive: 7500 },
      { class: 'Truck', msrp: 58000, incentive: 7500 },
      { class: 'Transit Bus', msrp: 400000, incentive: 150000 },
      { class: 'School Bus', msrp: 320000, incentive: 100000 }
    ]
  }
];

// Government Policy Library
export const mockPolicies = [
  {
    id: 'ca-zev-2024',
    name: 'California ZEV Mandate 2024',
    state: 'CA',
    type: 'mandate',
    description: 'Zero Emission Vehicle mandate targets',
    details: {
      zevTargets: [
        { year: 2025, percentage: 35 },
        { year: 2030, percentage: 68 },
        { year: 2035, percentage: 100 }
      ],
      incentives: {
        purchaseRebate: 7500,
        chargingInfrastructure: 5000
      }
    }
  },
  {
    id: 'ny-climate-act',
    name: 'NY Climate Leadership Act',
    state: 'NY',
    type: 'mandate',
    description: 'Climate goals and EV targets',
    details: {
      zevTargets: [
        { year: 2025, percentage: 25 },
        { year: 2030, percentage: 50 },
        { year: 2035, percentage: 100 }
      ],
      incentives: {
        purchaseRebate: 5000,
        chargingInfrastructure: 4000
      }
    }
  },
  {
    id: 'federal-ira-2024',
    name: 'Federal IRA Tax Credits',
    state: 'Federal',
    type: 'incentive',
    description: 'Inflation Reduction Act EV tax credits',
    details: {
      incentives: {
        purchaseRebate: 7500,
        usedVehicleCredit: 4000,
        chargingInfrastructure: 7500
      }
    }
  }
];

// Weather Dataset Library
export const mockWeatherDatasets = [
  {
    id: 'noaa-2020-2024',
    name: 'NOAA Climate Data 2020-2024',
    source: 'NOAA',
    years: '2020-2024',
    resolution: 'County-level',
    description: 'Historical weather patterns from NOAA stations',
    coverage: 'Nationwide',
    license: 'Public Domain'
  },
  {
    id: 'prism-2015-2024',
    name: 'PRISM Climate Dataset',
    source: 'PRISM Climate Group',
    years: '2015-2024',
    resolution: '4km grid',
    description: 'High-resolution spatial climate data',
    coverage: 'Continental US',
    license: 'Academic Use'
  }
];

// Demographics Dataset Library
export const mockDemographicsDatasets = [
  {
    id: 'census-acs-2022',
    name: 'ACS 5-Year 2018-2022',
    source: 'US Census Bureau',
    year: 2022,
    geography: 'Census Tract',
    description: 'American Community Survey 5-year estimates',
    variables: ['Population', 'Income', 'Housing Type', 'Vehicles per Household'],
    coverage: 'Nationwide',
    license: 'Public Domain'
  },
  {
    id: 'census-acs-2021',
    name: 'ACS 5-Year 2017-2021',
    source: 'US Census Bureau',
    year: 2021,
    geography: 'Census Tract',
    description: 'American Community Survey 5-year estimates',
    variables: ['Population', 'Income', 'Housing Type', 'Vehicles per Household'],
    coverage: 'Nationwide',
    license: 'Public Domain'
  }
];

// Travel Survey Library
export const mockTravelSurveys = [
  {
    id: 'nhts-2017',
    name: 'NHTS 2017',
    source: 'US DOT Federal Highway Administration',
    year: 2017,
    description: 'National Household Travel Survey',
    metrics: ['Trip Length', 'Trip Purpose', 'Departure Time', 'Vehicle Type'],
    sampleSize: '923,572 trips',
    coverage: 'Nationwide',
    license: 'Public Domain'
  },
  {
    id: 'ca-chts-2013',
    name: 'California CHTS 2012-2013',
    source: 'California DOT',
    year: 2013,
    description: 'California Household Travel Survey',
    metrics: ['Trip Length', 'Trip Purpose', 'Departure Time', 'Mode Choice'],
    sampleSize: '42,000 households',
    coverage: 'California',
    license: 'Public Domain'
  }
];

// Charging Infrastructure Data Sources
export const mockInfrastructureDataSources = [
  {
    id: 'afdc-stations',
    name: 'US AFDC Station Database',
    source: 'Alternative Fuels Data Center (NREL)',
    type: 'charging_infrastructure',
    description: 'Public and private charging stations across the US',
    lastUpdated: '2024-01-15',
    coverage: 'Nationwide',
    license: 'Public Domain',
    format: 'GeoJSON',
    url: 'https://developer.nrel.gov/docs/transportation/alt-fuel-stations-v1/'
  },
  {
    id: 'osm-pois',
    name: 'OpenStreetMap POIs',
    source: 'OpenStreetMap',
    type: 'pois',
    description: 'Points of interest including commercial, residential, and transit hubs',
    lastUpdated: '2024-01-20',
    coverage: 'Worldwide',
    license: 'ODbL',
    format: 'GeoJSON',
    url: 'https://www.openstreetmap.org/'
  }
];

// Mock summary data for utility region
export const mockUtilitySummary = {
  demographics: {
    population: 1250000,
    households: 485000,
    medianIncome: 75000,
    vehiclesPerHousehold: 1.8,
    housingTypes: {
      singleFamily: 62,
      multiFamily: 28,
      other: 10
    }
  },
  travel: {
    avgDailyTrips: 3.2,
    avgTripLength: 12.5, // miles
    peakDeparture: '7:00-9:00 AM',
    peakReturn: '5:00-7:00 PM'
  },
  weather: {
    avgTempSummer: 78, // °F
    avgTempWinter: 42,
    extremeHeat: 15, // days > 95°F
    extremeCold: 8 // days < 20°F
  },
  infrastructure: {
    existingStations: 145,
    level2Ports: 320,
    dcfcPorts: 68,
    avgUtilization: 32 // %
  }
};
